module.exports = "/_next/static/images/MapsJettyNew-a06d27de84edb64feee1f521b78ee208.png";